import React from 'react';
import { graphql } from 'gatsby';
import Wave from '@/components/elements/wave';
import { render } from '@/utils/story-composer';

export default function LibraryFooter({ storyblokComponent }) {
	return (
		<div>
			{storyblokComponent ? (
				render(storyblokComponent.content)
			) : (
				<>
					<Wave fillColor="MARINER" />
					<div className="bg-mariner h-20" />
				</>
			)}
		</div>
	);
}

export const query = graphql`
	# Re-usable query that can be used within multiple page-templates
	fragment LibraryFooterQuery on Query {
		libraryFooter: storyblokPublicLibraryComponents(
			slug: { eq: "get-started-footer" }
			lang: { in: [$locale, $languageCode] }
		) {
			content
		}
	}
`;
